import { Component, computed, inject, input } from '@angular/core';
import { FieldService, GenericLinkDirective } from '@core/jss-utils';
import type { LinkField, TextField } from '@core/jss-proxy';
import { CoreJssProxyModule } from '@core/jss-proxy';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { DeployUrlPipe } from '@innogy/utils/environment';
import { ENVIRONMENT_CONFIG, getBrandName } from '@core/config-angular';
import { CrntButtonAlt, CrntIcon } from '@essent/current-web-angular';
import { TranslatePipe } from '@ngx-translate/core';
import type {
  GetReviewsResponseWithStatistics,
  GetReviewStatisticsResponse,
} from '@integration/api-client/reviews';
import type { ReviewScoreWidgetType } from '@reviews/models';
import { ReviewStarsComponent } from '@reviews/ui/stars';

@Component({
  selector: 'wl-review-score',
  templateUrl: './review-score.component.html',
  standalone: true,
  styleUrls: [
    './review-score.component.ed.scss',
    './review-score.component.essent.scss',
  ],
  imports: [
    CoreJssProxyModule,
    ReviewStarsComponent,
    NgTemplateOutlet,
    GenericLinkDirective,
    DeployUrlPipe,
    CrntButtonAlt,
    TranslatePipe,
    CrntIcon,
    NgClass,
  ],
})
export class ReviewScoreComponent {
  /**
   * @deprecated this "title" should only be provided in the legacy ReviewScoreWidget, ReviewEntry
   *             & ReviewOverview container components. In the new ReviewsSection(s) this title should never be set.
   */
  readonly title = input<TextField | undefined>();
  readonly button = input<LinkField | undefined>();
  readonly stats = input.required<
    GetReviewStatisticsResponse | GetReviewsResponseWithStatistics
  >();
  readonly type = input<ReviewScoreWidgetType>('small');

  readonly #env = inject(ENVIRONMENT_CONFIG);
  readonly #fieldService = inject(FieldService);

  readonly showTitle = computed(() =>
    this.#fieldService.showTextField(this.title())
  );
  readonly showButton = computed(() =>
    this.#fieldService.showLinkField(this.button())
  );

  readonly showCard = input(true);

  readonly brand = getBrandName(this.#env.brand);

  readonly logoSize = computed<'small' | 'large'>(() =>
    this.type() === 'overview' ? 'large' : 'small'
  );

  readonly cardStyles = computed(() =>
    this.type() === 'entry' ? '' : 'p-2 rounded bg-white border'
  );
}
